/* ============================================================
   Warenkorb — Fortschrittsbalken aus Reiskörnern.

   Zeigt zwei Schwellen auf einer Skala: den Mindestbestellwert und den Betrag, ab dem
   versandkostenfrei geliefert wird. Die Skala reicht von 0 bis zum Versandkostenfrei-
   Betrag; die Mindestbestellwert-Marke sitzt anteilig darauf.

   Die Reiskorn-Darstellung stammt aus der Magazin-Verkaufsseite und ist hier übernommen:
   Ellipsen mit Verlauf, Glanzlicht und Schatten, verteilt über ein leicht zufällig
   gestörtes Raster.

   KEINE Animation. Körner erscheinen und verschwinden ohne Übergang, und der Balken
   füllt sich ausschließlich in ganzen Körnern.

   Der Kern dafür ist die feste Belegung: Die Körner für den VOLLEN Balken werden einmal
   berechnet und nach ihrer x-Lage sortiert; gezeichnet werden dann die ersten N davon.
   Dadurch bleibt jedes vorhandene Korn beim Nachlegen exakt an seinem Platz — würde man
   die Belegung für jeden Füllstand neu berechnen (wie es die Magazin-Seite tut, wo sie
   nur einmal beim Laden entsteht), sprängen bei jedem Mengenklick sämtliche Körner um.

   Die Zufallszahlen kommen aus einem Generator mit FESTEM Startwert, damit dieselbe
   Belegung auch nach einem Neuladen wieder entsteht.

   Die Beträge kommen als data-Attribute aus dem Markup (in Cent), damit sie sich ohne
   Eingriff in dieses Skript ändern lassen.
   ============================================================ */
(function () {
  'use strict';

  var BAR_HEIGHT = 52;

  function seededRand(seed) {
    var s = seed;
    return function () {
      s = (s * 1664525 + 1013904223) & 0xffffffff;
      return (s >>> 0) / 0xffffffff;
    };
  }

  function drawRiceGrain(ctx, cx, cy, angle, sw, sh) {
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(angle);
    var gw = sw, gh = sh;
    ctx.beginPath(); ctx.ellipse(1, 1.5, gw / 2, gh / 2, 0, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(120,100,50,0.18)'; ctx.fill();
    var grad = ctx.createRadialGradient(-gw * 0.18, -gh * 0.28, gh * 0.04, 0, 0, gw * 0.58);
    grad.addColorStop(0, '#FEFCF4'); grad.addColorStop(0.25, '#F2EDD8');
    grad.addColorStop(0.6, '#DDD0A2'); grad.addColorStop(1, '#C8B878');
    ctx.beginPath(); ctx.ellipse(0, 0, gw / 2, gh / 2, 0, 0, Math.PI * 2);
    ctx.fillStyle = grad; ctx.fill();
    var hl = ctx.createLinearGradient(-gw * 0.3, -gh * 0.4, gw * 0.1, gh * 0.1);
    hl.addColorStop(0, 'rgba(255,255,255,0.65)');
    hl.addColorStop(0.5, 'rgba(255,255,255,0.15)');
    hl.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.beginPath(); ctx.ellipse(-gw * 0.08, -gh * 0.12, gw * 0.28, gh * 0.22, -0.4, 0, Math.PI * 2);
    ctx.fillStyle = hl; ctx.fill();
    ctx.beginPath(); ctx.ellipse(0, 0, gw / 2, gh / 2, 0, 0, Math.PI * 2);
    ctx.strokeStyle = 'rgba(150,125,65,0.3)'; ctx.lineWidth = 0.6; ctx.stroke();
    ctx.restore();
  }

  // Belegung für den VOLLEN Balken. Nach x sortiert, damit sich der Balken von links
  // nach rechts füllt, wenn nur die ersten N Körner gezeichnet werden.
  function buildFullBar(W, H) {
    // Kornzahl wächst mit der Balkenbreite mit, damit die Dichte auf jedem Bildschirm
    // gleich aussieht.
    var refWidth = 600;
    var count = Math.round(650 * W / refWidth);
    if (count <= 0) return [];
    var rand = seededRand(42);
    var margin = 8;
    var gridW = W + margin * 2;
    var gridH = H + margin * 2;
    var cols = Math.ceil(Math.sqrt(count * gridW / gridH));
    var rows = Math.ceil(count / cols);
    var cellW = gridW / cols;
    var cellH = gridH / rows;
    var grains = [];
    for (var row = 0; row < rows; row++) {
      for (var col = 0; col < cols; col++) {
        if (grains.length >= count) break;
        var cx = -margin + (col + 0.5) * cellW + (rand() - 0.5) * cellW * 0.75;
        var cy = -margin + (row + 0.5) * cellH + (rand() - 0.5) * cellH * 0.75;
        grains.push({
          cx: cx, cy: cy,
          angle: (rand() - 0.5) * Math.PI,
          sw: 15 * (0.82 + rand() * 0.36),
          sh: 9 * (0.82 + rand() * 0.36)
        });
      }
    }
    grains.sort(function (a, b) { return a.cx - b.cx; });
    return grains;
  }

  // Ein Korn einmal in ein eigenes kleines Canvas zeichnen und danach nur noch kopieren.
  //
  // Der Grund ist die Geschwindigkeit: Jedes Korn besteht aus zwei Verläufen, einem
  // Glanzlicht, einem Schatten und einer Kontur. Das für 650 Körner bei JEDER Änderung neu
  // zu rechnen, ist der eigentliche Bremsklotz. Als fertiges Bildchen kostet ein Korn nur
  // noch einen drawImage-Aufruf — das ist um Größenordnungen schneller und sieht identisch
  // aus, weil dasselbe gezeichnet wird, nur einmal statt immer wieder.
  function makeGrainSprite(sw, sh, angle) {
    var pad = 4;
    var size = Math.ceil(Math.max(sw, sh) + pad * 2);
    var c = document.createElement('canvas');
    c.width = size;
    c.height = size;
    var ctx = c.getContext('2d');
    drawRiceGrain(ctx, size / 2, size / 2, angle, sw, sh);
    return c;
  }

  function init(root) {
    // Doppelte Einrichtung verhindern: boot() laeuft jetzt auch nach dem Neuaufbau einer
    // Sektion, und dieselbe Leiste soll dabei nicht zweimal Verarbeiter bekommen.
    if (root.dataset.riceInit) return;
    root.dataset.riceInit = '1';

    var canvas = root.querySelector('[data-rice-canvas]');
    var track = root.querySelector('[data-rice-track]');
    var statusEl = root.querySelector('[data-rice-status]');
    var totalEl = root.querySelector('[data-rice-total]');
    var markMin = root.querySelector('[data-rice-mark-min]');
    var markFree = root.querySelector('[data-rice-mark-free]');
    var labelMin = root.querySelector('[data-rice-label-min]');
    var labelFree = root.querySelector('[data-rice-label-free]');
    if (!canvas || !track) return;

    // Wortlaut und Eurodarstellung kommen aus assets/cart-hinweis.js — dieselbe Quelle,
    // aus der sich auch der kleine Balken im Header bedient. Die Rückfallebene ist
    // wortgleich, falls die Datei einmal nicht geladen ist.
    var HINWEIS = window.cartHinweis || {
      euro: function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; },
      betrag: function (c) { return '€' + (c / 100).toFixed(2).replace('.', ','); },
      stufe: function (total, min, free, max) {
        if (max && total >= max) return 'max';
        if (total < min) return 'min';
        if (total < free) return 'versand';
        return 'frei';
      },
      skala: function (free, max) { return max && max > 0 ? max : free; },
      text: function (total, min, free, max) {
        if (max && total >= max) return 'Maximaler Bestellwert erreicht';
        if (total < min) return 'Noch ' + this.euro(min - total) + ' bis zum Mindestbestellwert';
        if (total < free) return 'Noch ' + this.euro(free - total) + ' bis versandkostenfrei';
        return 'Versandkostenfrei erreicht';
      }
    };

    // HINWEIS muss VOR SKALA stehen. Beide sind mit var deklariert und werden dadurch an
    // den Anfang der Funktion hochgezogen — der WERT aber nicht. Stand die Zuweisung
    // weiter unten, war HINWEIS bei der SKALA-Zeile noch undefined und der Zugriff
    // HINWEIS.skala warf einen TypeError. Der brach init() ab: kein Text, keine Koerner,
    // kein Balken. Sichtbar war das erst nach der Umstellung auf laenderabhaengige
    // Schwellen, weil SKALA dabei neu hinzukam.

    var MIN = parseInt(root.dataset.min, 10) || 0;
    var FREE = parseInt(root.dataset.free, 10) || 0;
    // Hoechstbestellwert. 0 heisst: keiner — nur die Schweiz hat einen.
    var MAX = parseInt(root.dataset.max, 10) || 0;
    // Bezugsgroesse des Balkens: bis zur Obergrenze, sonst bis versandkostenfrei.
    var SKALA = HINWEIS.skala ? HINWEIS.skala(FREE, MAX) : FREE;
    var grains = [];
    var barWidth = 0;
    var ctx2d = null;
    var lastTotal = parseInt(root.dataset.total, 10) || 0;

    function euro(cents) {
      return HINWEIS.euro(cents);
    }

    function layout(W) {
      barWidth = W;
      grains = buildFullBar(W, BAR_HEIGHT);
      // Jedem Korn sein fertiges Bildchen zuordnen. Passiert einmal pro Breite, nicht
      // bei jeder Mengenänderung.
      grains.forEach(function (g) {
        g.sprite = makeGrainSprite(g.sw, g.sh, g.angle);
      });
      ctx2d = canvas.getContext('2d');
    }

    function paint(total) {
      var W = track.clientWidth || 600;
      if (W !== barWidth || !grains.length) layout(W);

      // Die Größe nur setzen, wenn sie sich geändert hat: Ein Schreiben auf canvas.width
      // leert die Fläche und wirft den internen Zustand weg, auch wenn derselbe Wert
      // zugewiesen wird.
      if (canvas.width !== W) {
        canvas.width = W;
        canvas.height = BAR_HEIGHT;
        canvas.style.width = W + 'px';
      }

      ctx2d.clearRect(0, 0, W, BAR_HEIGHT);

      // Ganze Körner: Der Anteil wird auf eine Kornzahl gerundet, es gibt kein halbes.
      var fraction = SKALA > 0 ? Math.min(1, total / SKALA) : 0;
      var visible = Math.round(fraction * grains.length);
      for (var i = 0; i < visible; i++) {
        var g = grains[i];
        var half = g.sprite.width / 2;
        ctx2d.drawImage(g.sprite, g.cx - half, g.cy - half);
      }
    }

    function render(total) {
      lastTotal = total;

      // betrag() statt euro(): dieselbe Schreibweise wie die Summe darunter
      // (.totals__total-value, €21,99). Der Hinweissatz daneben benutzt weiter euro(),
      // weil das Zeichen bei Differenzen im Fließtext hinten natuerlicher liest.
      if (totalEl) totalEl.textContent = HINWEIS.betrag ? HINWEIS.betrag(total) : euro(total);

      if (statusEl) statusEl.textContent = HINWEIS.text(total, MIN, FREE, MAX);

      // Marken sitzen anteilig auf der Skala. Gibt es eine Obergrenze, reicht die Skala
      // bis dorthin und der Versandkostenfrei-Betrag bekommt eine eigene Marke DARIN;
      // ohne Obergrenze liegt er am Ende und braucht keine.
      if (markMin && SKALA > 0) {
        markMin.style.left = (MIN / SKALA * 100) + '%';
        markMin.classList.toggle('is-reached', total >= MIN);
      }
      if (markFree) {
        markFree.hidden = !(MAX > 0);
        if (MAX > 0 && SKALA > 0) {
          markFree.style.left = (FREE / SKALA * 100) + '%';
          markFree.classList.toggle('is-reached', total >= FREE);
        }
      }

      if (labelMin) labelMin.textContent = 'Mindestbestellwert ' + euro(MIN);
      if (labelFree) {
        labelFree.textContent = MAX > 0
          ? 'Versandkostenfrei ab ' + euro(FREE) + ' · Höchstbestellwert ' + euro(MAX)
          : 'Versandkostenfrei ab ' + euro(FREE);
      }

      root.dataset.stufe = HINWEIS.stufe(total, MIN, FREE, MAX);
      root.classList.toggle('is-below-min', total < MIN);
      root.classList.toggle('is-free', total >= FREE && !(MAX && total >= MAX));
      root.classList.toggle('is-max', !!(MAX && total >= MAX));

      // Der Schein erlischt erst, wenn der Mindestbestellwert erreicht ist. Frueher nahm
      // ihn ein Zeitablauf nach sechs Sekunden weg, auch wenn der Betrag weiterhin zu
      // niedrig war. Jetzt haengt er am Betrag: Wer nachlegt, sieht ihn ausgehen.
      if (total >= MIN) root.classList.remove('is-glowing');

      paint(total);
    }

    function refreshFromCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart.total_price); })
        .catch(function () { /* Netzfehler: der zuletzt gezeigte Stand bleibt stehen */ });
    }

    // Gelben Schein auf der Statuszeile auslösen. Eine laufende Animation startet nicht
    // erneut, solange die Klasse gesetzt ist — deshalb erst entfernen, dann ein
    // erzwungenes Neuberechnen des Layouts (offsetWidth lesen), dann wieder setzen.
    function glow() {
      root.classList.remove('is-glowing');
      void root.offsetWidth;
      root.classList.add('is-glowing');
    }

    // Frueher raeumte hier ein animationend-Auslauf die Klasse ab. Das ist entfallen:
    // Beendet wird der Schein jetzt in render(), sobald der Mindestbestellwert erreicht ist.

    // Sperre unter dem Mindestbestellwert.
    //
    // Bewusst NICHT über disabled am Kasse-Knopf: Ein deaktivierter Knopf feuert beim
    // Klick gar kein Ereignis, der Schein liesse sich dann nicht auslösen und der Kunde
    // stünde vor einem toten Knopf ohne Erklärung.
    //
    // Abgefangen wird der KLICK und nicht das Absenden — und darin steckt die Reihenfolge:
    // Der Browser prüft die Pflichtfelder (also die Lieferbarkeitsfrage) erst, wenn ein
    // Absendeversuch tatsächlich beginnt. Wer den Klick vorher abbricht, verhindert diese
    // Prüfung. Dadurch wird zuerst der Mindestbestellwert angemahnt, und die
    // Lieferbarkeitsfrage kommt erst zum Zug, wenn der Betrag stimmt.
    function blockIfBelowMin(event) {
      if (lastTotal >= MIN) return;
      event.preventDefault();
      event.stopPropagation();
      glow();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    var checkoutBtn = document.getElementById('checkout');
    if (checkoutBtn) checkoutBtn.addEventListener('click', blockIfBelowMin, true);

    // Zusätzlich am Formular, für den Fall, dass jemand mit der Eingabetaste absendet.
    var cartForm = document.getElementById('cart');
    if (cartForm) cartForm.addEventListener('submit', blockIfBelowMin, true);

    // Erster Aufbau aus dem serverseitig gerenderten Wert, ohne Wartezeit auf /cart.js.
    render(lastTotal);

    // Aktualisierung: Dawn meldet jede Warenkorbänderung über seinen eigenen Ereignisbus,
    // und die Meldung enthält den neuen Warenkorb bereits. Damit entfällt beides, was den
    // Balken bisher träge machte — die feste Wartezeit von 600 ms und eine zusätzliche
    // Abfrage von /cart.js. Der Balken steht jetzt im selben Moment wie die neue Summe.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var data = event && event.cartData;
        if (data && typeof data.total_price === 'number') render(data.total_price);
        else refreshFromCart();
      });
    } else {
      // Rückfallebene, falls pubsub.js einmal nicht geladen ist.
      document.addEventListener('change', function (e) {
        if (e.target.closest('cart-items, cart-drawer-items')) setTimeout(refreshFromCart, 600);
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest('cart-remove-button, .quantity__button')) setTimeout(refreshFromCart, 600);
      });
    }

    window.addEventListener('resize', function () { paint(lastTotal); });

    // NACHZEICHNEN, wenn die Seite wieder sichtbar wird.
    //
    // Ein Canvas merkt sich seinen Inhalt nicht: Er lebt in einer Zeichenflaeche, die der
    // Browser bei Speicherdruck, im Hintergrund liegendem Tab oder Verlust des
    // Grafikkontexts wegwerfen darf. Danach ist die Flaeche leer, und bisher hat sie nichts
    // wieder gefuellt — gezeichnet wurde nur bei Warenkorbaenderung und beim Fenstergroesse-
    // Aendern. Wer den Warenkorb lange offen liegen liess, fand die Koerner verschwunden.
    //
    // pageshow deckt zusaetzlich den Ruecksprung aus dem Verlauf ab (Zurueck-Taste), wo die
    // Seite aus dem Zwischenspeicher kommt und ebenfalls nicht neu gezeichnet wird.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) paint(lastTotal);
    });
    window.addEventListener('pageshow', function () { paint(lastTotal); });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-rice]'), init);
  }

  // Sektion neu aufgebaut (Theme-Editor, und beim Entwicklungsserver auch das automatische
  // Neuladen nach einer Dateiaenderung): Das Markup samt Canvas ist dann ausgetauscht und
  // leer. boot() richtet die neue Leiste ein und zeichnet sie.
  document.addEventListener('shopify:section:load', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
